<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white" v-show="JSON.stringify(data) != '{}'">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/task" class="cl_gray">作业记录</router-link>  >  {{data.name}}</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="record_title">
					<div class="record_list_title">
						<span class="cl_white record_list_type">{{data.type_name}}</span>
						<span class="cl_violet record_list_subject">{{data.subject_name}}</span>
						<span class="f20px cl_dark">{{data.name}}</span>
					</div>
					<div class="record_title_btm cl_dark mat20">
						<div class="record_title_item">
							<p>状态：<span class="cl_gray">{{data.status}}</span></p>
							<p class="mat5">已参与人数：<span class="cl_gray">{{data.class_join_num}}/{{data.class_all_num}}</span></p>
						</div>
						<div class="record_title_item">
							<p>布置人：<span class="cl_gray">{{data.add_user_name}}</span></p>
							<p class="mat5">已完成人数：<span class="cl_gray">{{data.class_done_num}}/{{data.class_all_num}}</span></p>
						</div>
						<div class="record_title_item">
							<p>布置对象：<span class="cl_gray">{{data.class_name}}</span></p>
							<p class="mat5">开始时间：<span class="cl_gray">{{data.from_time}}</span></p>
						</div>
						<div class="record_title_item">
							<p>结束时间：<span class="cl_gray">{{data.to_time}}</span></p>
						</div>
					</div>
				</div>
				<div class="record_nav f18px cl_dark">
					<div class="record_nav_list cur" v-for="(item,index) in nav" :key="index" :class="{'on':nav_cur==item.id}"
					@click="navCheck(item.id)">{{item.name}}</div>
				</div>
				<div class="record_overview" v-if="nav_cur == 1">
					<div class="record_overview_list">
						<div class="record_overview_list_l">
							<p class="f20px cl_dark tc">总览</p>
							<p class="cl_yel mat15">作业数据有半小时左右延迟，学生人数会有出入，请各位老师耐心等待！</p>
						</div>
						<div class="record_overview_list_r flex">
							<div id="all" style="width: 200px;height: 200px;"></div>
							<div class="record_overview_all f16px">总人数：{{data.class_all_num}}</div>
							<div class="cl_blue record_overview_not cur" @click="notJoin()">查看名单></div>
						</div>
					</div>
					<div class="record_overview_list">
						<div class="record_overview_list_l">
							<p class="f20px cl_dark tc">视频</p>
						</div>
						<div class="record_overview_list_r flex">
							<div>
								<p class="tc f18px cl_dark">观看情况</p><br>
								<Progress strokeColor="#AFA9FE" :radius="45" :strokeWidth="5" :value="data.video_probability">
									<div class="f20px">{{data.video_probability == 0 ? '-' : data.video_probability}}%</div>
								</Progress>
							</div>
							<div class="cl_gray mat30 mal20">
								<p>观看数量：{{data.pack_view_num}}</p>
								<p class="mat5">未观看：{{data.pack_all_num-data.pack_view_num}}</p>
							</div>
						</div>
					</div>
					<div class="record_overview_list">
						<div class="record_overview_list_l">
							<p class="f20px cl_dark tc">试卷</p>
						</div>
						<div class="record_overview_list_r">
							<p class="tc f18px cl_dark">平均正确率</p><br>
							<Progress strokeColor="#AFA9FE" :radius="45" :strokeWidth="5" :value="data.average_accuracy">
								<div class="f20px">{{data.average_accuracy == 0 ? '-' : data.average_accuracy}}%</div>
							</Progress>
						</div>
					</div>
				</div>
				<div class="mat30" v-if="nav_cur == 2">
					<table class="record_table">
						<thead>
							<tr>
								<th>姓名</th>
								<th>任务总进度</th>
								<th>视频完成进度</th>
								<th>试卷完成进度</th>
								<th>其他完成进度</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody class="cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td>{{item.user_name}}</td>
								<td>
									<span v-if="item.all_num==0">-</span>
									<span v-else>{{item.all_done_num}}/{{item.all_num}}</span>
								</td>
								<td>
									<span v-if="item.video_all_num==0">-</span>
									<span v-else>{{item.video_done_num}}/{{item.video_all_num}}</span>
								</td>
								<td>
									<span v-if="item.papers_all_num==0">-</span>
									<span v-else>{{item.papers_done_num}}/{{item.papers_all_num}}</span>
								</td>
								<td>
									<span v-if="item.exam_all_num==0">-</span>
									<span v-else>{{item.exam_done_num}}/{{item.exam_all_num}}</span>
								</td>
								<td><span class="cl_blue cur" @click="task(item.user_id,item.user_name)">学生作业详情</span></td>
							</tr>
						</tbody>
					</table>
					<div class="famous_page flex" v-if="list.length > 0">
						<div class="famous_page_l f16px cl_gray"> </div>
						<div class="famous_page_r cl_dark">
							<el-pagination background layout="prev, pager, next"
							@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 未参与学生名单 -->
		<el-dialog title="未参与学生名单" center :visible.sync="not_join" width="40%">
			<div class="not_join f16px cl_gray tc">
				<div class="not_join_list" v-for="(item,index) in student" :key="index">{{item}}</div>
			</div>
			<div class="basket_dialog_btm tc mat50">
				<button type="button" class="basket_dialog_submit f18px cl_white radius20" @click="not_join=false">关闭</button>
			</div>
		</el-dialog>
		<!-- 作业完成情况 -->
		<el-dialog :title="user_name + '同学作业完成情况'" center :visible.sync="task_show" width="70%">
			<table class="record_table">
				<thead>
					<tr>
						<th width="120px">学科</th>
						<th width="120px">任务类型</th>
						<th width="300px">任务名称</th>
						<th width="120px">完成状态</th>
						<th width="180px">完成时间</th>
						<th width="180px">完成情况</th>
					</tr>
				</thead>
				<tbody class="cl_dark">
					<tr v-for="(item,index) in task_list" :key="index">
						<td>{{item.subject_name}}</td>
						<td>{{item.type}}</td>
						<td>{{item.name}}</td>	
						<td>{{item.status}}</td>
						<td>{{item.done_time}}</td>
						<td>
							<p v-if="item.status!='已完成'">-</p>
							<p v-if="item.type=='试卷' && item.status=='已完成'">答题时长：{{item.time}}</p>
							<p v-if="item.type=='组卷' && item.status=='已完成'">正确率：{{item.accuracy}}%</p>
							<p v-if="item.type=='校本试卷' && item.status=='已完成'">总得分：{{item.total_points}}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="basket_dialog_btm tc mat50">
				<button type="button" class="basket_dialog_submit f18px cl_white radius20" @click="task_show=false">关闭</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	import Progress from 'easy-circular-progress'
	// echarts
	import * as echarts from 'echarts/core';
	import { TitleComponent, TooltipComponent, LegendComponent } from 'echarts/components';
	import { PieChart } from 'echarts/charts';
	import { CanvasRenderer } from 'echarts/renderers';
	echarts.use(
	   [TitleComponent, TooltipComponent, LegendComponent, PieChart, CanvasRenderer]
	);
	
	export default {
		name: 'record',
		components: {
			teacherNav,
			Progress,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 4,
					listCur: 0,
					open: 0,
				},
				id: "",
				student: [],
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				nav: [
					{
						id: 1,
						name: "作业概览",
					},{
						id: 2,
						name: "班级完成情况",
					},
				],
				nav_cur: 1,
				data: {},
				not_join: false,
				task_show: false,
				task_list: [],
				user_id: "",
				user_name: "",
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getDetails();
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//概览
			getDetails () {
				this.$get("/api/teacher/get_homework_overview_data",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.data = res.data;
					if (this.data.pack_all_num == 0) {
						this.data.video_probability = 0;
					} else {
						this.data.video_probability = parseInt(this.data.pack_view_num/this.data.pack_all_num*100);
					}
					let data = [];
					data.push({value: this.data.class_done_num, name: '已完成'},
					{value: this.data.class_join_num, name: '进行中'},
					{value: this.data.class_all_num - this.data.class_join_num-this.data.class_done_num, name: '未参与'})
					
					var chartDom = document.getElementById('all');
					var myChart = echarts.init(chartDom);
					var option;
					option = {
						tooltip: {
							trigger: 'item'
						},
						legend: {
							top: 'middle',
							right: '0',
							orient: 'vertical',
						},
						series: [
							{
								name: '总览',
								type: 'pie',
								radius: '55%',
								center: ['30%', '50%'],
								labelLine: {
									show: false
								},
								label: {
									show: false,
									position: 'center'
								},
								data: data
							}
						]
					};
					option && myChart.setOption(option);
				});
			},
			navCheck (id) {
				this.nav_cur = id;
				if (id == 2) {
					this.currentPage = 1;
					this.getList();
				} else {
					this.getDetails();
				}
			},
			//未完成名单
			notJoin () {
				this.$get("/api/teacher/get_not_participation_student_list",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.student = res.data;
					this.not_join = true;
				});
			},
			//班级完成情况
			getList () {
				this.$get("/api/teacher/get_homework_class_condition_list",{
					token: localStorage.getItem("token"),
					id: this.id,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			task (id,name) {
				this.task_show = true;
				this.user_id = id;
				this.user_name = name;
				this.$get("/api/teacher/get_student_condition_list",{
					token: localStorage.getItem("token"),
					id: this.id,
					user_id: this.user_id,
				})
				.then(res => {
					this.task_list = res.data.list;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
